import ky from 'ky';

// Create the base API instance
const api = ky.create({ prefixUrl: import.meta.env.VITE_API_BASE });

// In-memory device ID for immediate use before hooks are set up
let currentDeviceId: string | null = null;

// Get device ID from localStorage if available
try {
  currentDeviceId = localStorage.getItem('device_id');
} catch (e) {
  // localStorage not available (e.g., incognito mode)
}

// Configure global request hooks
api.extend({
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set('X-Requested-With', 'ky');

        // Add device ID header if available
        if (currentDeviceId) {
          request.headers.set('x-device-id', currentDeviceId);
        }
      },
    ],
  },
});

// Function to update the device ID used in requests
export const setApiDeviceId = (deviceId: string) => {
  currentDeviceId = deviceId;

  // Update the API instance with the new device ID
  api.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set('X-Requested-With', 'ky');
          request.headers.set('x-device-id', deviceId);
        },
      ],
    },
  });
};

export default api;
